// extracted by mini-css-extract-plugin
export default {"Panel":"KjAesf2k","Primary":"kWABECvi","Secondary":"LRRTOJeR","TabbedPanel":"JgSXO2FG","TabbedContainer":"aGIusrOl"};